import { get, set } from 'idb-keyval'

import { PinnedTab } from '.'

export const getPinnedTabs = async (userId: string, userEnv: string) => {
  try {
    const key = `${userId}__${userEnv}__pinnedTabs`
    return (await get(key)) ?? []
  } catch (err) {
    console.error(`error getting pinned notes! ${err}`)
  }
}

export const savePinnedTabs = async (
  userId: string,
  userEnv: string,
  tabs: PinnedTab[]
) => {
  try {
    const key = `${userId}__${userEnv}__pinnedTabs`
    await set(key, tabs)
  } catch (err) {
    console.error(`error saving notes activity! ${err}`)
  }
}
